import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import SwimmingPoolListTable from './Components/SwimmingPoolListTable'

const SwimmingPoolList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Swimming Pool List</HeadingOne>
                    <AddItemBtn url="add-swimming-pool" title="Create Swimming Pool" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <SwimmingPoolListTable />
            </div>
        </PageBody>
    )
}

export default SwimmingPoolList;